<template>
  <Notification
    :description="
      $t('rc_notifications_no_budget', {
        month: formatDate(budgetRenewDate, { month: 'long' }),
      })
    "
    v-bind="$attrs"
  >
    <template #ctaContent>
      <div class="tw:mt-3 tw:md:mt-0 tw:shrink-0">
        <BaseLinkButton
          size="medium"
          class="tw:w-full tw:font-bold tw:text-blue-800 tw:text-nowrap"
          @click="navigateToBudget"
        >
          <span>{{ $t('notification_action_update_budget') }}</span>
        </BaseLinkButton>
      </div>
    </template>
  </Notification>
</template>

<script setup>
import { computed } from 'vue'
import { useRouter } from 'vue-router'

import Notification from './Notification.vue'
import BaseLinkButton from '@/components/base/buttons/BaseLinkButton.vue'

import { useFormatting } from '@/composables/useFormatting'

const router = useRouter()
const { formatDate } = useFormatting()
const budgetRenewDate = computed(() => {
  const now = new Date()
  return new Date(now.getFullYear(), now.getMonth() + 1, 1)
})

const navigateToBudget = () => {
  router.push({ path: 'budget' })
}
</script>
